export function normalizeSiteUrl(value: string): string {
	const trimmed = value.trim().replace(/\/+$/, "")
	if (!trimmed) return ""
	return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`
}
